export default __webpack_public_path__ + "static/media/gogocurry.c46e91ff.jpeg";